import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createProductAndPurchaseDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('ProductAndPurchase').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.ProductAndPurchasePostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('ProductAndPurchase').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getProductAndPurchaseDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductAndPurchase').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getProductAndPurchaseDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductAndPurchase').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getProductAndPurchaseDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('ProductAndPurchase').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllProductAndPurchaseDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ProductAndPurchase').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateProductAndPurchaseDocument = async (product) => {
    const docRef = db.doc(`/ProductAndPurchase/${product._id}`);
    return docRef.update(product);
}